import { Language, Message } from 'dg-web-shared/lib/Localized';
import { SavedCreditCardAliasResponse } from 'dg-web-shared/model/PaymentAlias';
import { CustomerTenantLegalForm } from 'dg-web-shared/common/models/Users.tsx';
import {
    VehicleIdentification,
    ParkingaboCustomerPaymentMode,
} from 'product-shared/parkingabo/ParkingaboOperatingMode.tsx';
import { ParkingaboContact } from 'product-shared/parkingabo/ParkingaboContact.ts';

export const MAX_CONTAINER_WIDTH = 444;

export enum AliasInvalidReason {
    ONBOARDING_REQUIRED = 'ONBOARDING_REQUIRED',
    NOT_FOUND = 'NOT_FOUND',
    LAST_DIRECT_FAILED = 'LAST_DIRECT_FAILED',
    EXPIRED = 'EXPIRED',
}

export interface ParkingaboUser {
    operatorExternalId: string;
    operatorName: string;
    parkingaboContact: ParkingaboContact | null;
    role: ParkingaboRole;
    customerNr: string;
    customerState: CustomerTenantState;
    email: string;
    requestedEmail: string | null;
    language: Language;
    firstName: string | null;
    lastName: string | null;
    company1: string | null;
    company2: string | null;
    legalForm: CustomerTenantLegalForm;
    alias: SavedCreditCardAliasResponse;
    aliasInvalidReason: AliasInvalidReason | null;
    overduePaymentsAmountRappen: number | null;
    nextPaymentCollectionDate: string;
    hasProductAvailable: boolean;
    onboardingCompleteTime: string | null;
}

export interface ParkingaboRole {
    roleId: string;
    name: Message;
    allowedCustomerLegalForm: CustomerTenantLegalForm;
    operatingModeId: number;
    vehicleIdentification: VehicleIdentification[];
    paymentMode: ParkingaboCustomerPaymentMode;
    hasAppSignupEmailDomains: boolean;
}

export const enum CustomerTenantState {
    ACTIVE = 'ACTIVE',
    LOCKED = 'LOCKED',
    ARCHIVED = 'ARCHIVED',
}
